module.exports = __webpack_public_path__ + "img/11.c616e8b0.jpg";